<template>
  <section
    class="w-full bg-gray-light "
  >
    <div class="flex flex-row">
      <div class="w-full py-4 text-black text-center font-source-serif-pro">
        <h2 class="inline text-2xl font-semibold ">
          {{ title }}
        </h2>
      </div>
      <slot>
        <div
          v-if="sub && link"
          class="lg:w-36 py-4 text-center bg-gray-light"
        >
          <nuxt-link
            
            class="font-source-serif-pro text-lg text-white underline"
            :to="link"
          >
            {{ sub }}
          </nuxt-link>
        </div>
      </slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    },
    sub: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    }
  }
};
</script>

